
import axios from "axios";
import { Payout_Service } from "../Url";

export const partnerDetailbyStatusAction = {
  PARTNER_DETAIL_FOR_PENDING_APPROVAL_SUCCESS: "PARTNER_DETAIL_FOR_PENDING_APPROVAL_SUCCESS",
  PARTNER_DETAIL_FOR_PENDING_APPROVAL_ERROR: "PARTNER_DETAIL_FOR_PENDING_APPROVAL_ERROR",
  PARTNER_DETAIL_FOR_APPROVED_SUCCESS :"PARTNER_DETAIL_FOR_APPROVED_SUCCESS",
  PARTNER_DETAIL_FOR_APPROVED_ERROR :"PARTNER_DETAIL_FOR_APPROVED_ERROR",
  PARTNER_DETAIL_FOR_REJECTED_SUCCESS :"PARTNER_DETAIL_FOR_REJECTED_SUCCESS",
  PARTNER_DETAIL_FOR_REJECTED_ERROR :"PARTNER_DETAIL_FOR_REJECTED_ERROR",
  PARTNER_DETAIL_FOR_QUERY_SUCCESS:"PARTNER_DETAIL_FOR_QUERY_SUCCESS",
  PARTNER_DETAIL_FOR_QUERY_ERROR:"PARTNER_DETAIL_FOR_QUERY_ERROR",
  PARTNER_DETAIL_FOR_RESOLVED_SUCCESS:"PARTNER_DETAIL_FOR_RESOLVED_SUCCESS",
  PARTNER_DETAIL_FOR_RESOLVED_ERROR:"PARTNER_DETAIL_FOR_RESOLVED_ERROR",
  
};

export function partnerDetailForPendingApproval(props) {
  const { accessToken } = props;
  return async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        headers: {
          authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Origin": "*",
        },
        // url: "http://localhost:8301/partner-payout-service/pricing/partner-by-stages?stage=1",
        url: `${Payout_Service}/pricing/partner-by-stages?stage=1`,
      });
      const data = response.data;
      dispatch({
        type: partnerDetailbyStatusAction.PARTNER_DETAIL_FOR_PENDING_APPROVAL_SUCCESS,
        payload: data.data,
      });
      return data.data;
    } catch (error) {
      console.error("Error:", error);
      dispatch({
        type: partnerDetailbyStatusAction.PARTNER_DETAIL_FOR_PENDING_APPROVAL_ERROR,
        payload: error.message || "Failed to fetch partner data",
      });
    }
  };
}
export function partnerDetailForApproved(props) {
  const { accessToken } = props;
  return async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        headers: {
          authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Origin": "*",
        },
        // url: "http://localhost:8301/partner-payout-service/pricing/partner-by-stages?stage=4",
        url: `${Payout_Service}/pricing/partner-by-stages?stage=4`,
      });
      const data = response.data;
      dispatch({
        type: partnerDetailbyStatusAction.PARTNER_DETAIL_FOR_APPROVED_SUCCESS,
        payload: data.data,
      });
      return data.data;
    } catch (error) {
      console.error("Error:", error);
      dispatch({
        type: partnerDetailbyStatusAction.PARTNER_DETAIL_FOR_APPROVED_ERROR,
        payload: error.message || "Failed to fetch partner data",
      });
    }
  };
}  
export function partnerDetailForRejected(props) {
  const { accessToken } = props;
  return async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        headers: {
          authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Origin": "*",
        },
        // url: "http://localhost:8301/partner-payout-service/pricing/partner-by-stages?stage=5",
        url: `${Payout_Service}/pricing/partner-by-stages?stage=5`,
      });
      const data = response.data;
      dispatch({
        type: partnerDetailbyStatusAction.PARTNER_DETAIL_FOR_REJECTED_SUCCESS,
        payload: data.data,
      });
      return data.data;
    } catch (error) {
      console.error("Error:", error);
      dispatch({
        type: partnerDetailbyStatusAction.PARTNER_DETAIL_FOR_REJECTED_ERROR,
        payload: error.message || "Failed to fetch partner data",
      });
    }
  };
}
export function partnerDetailForQuery(props) {
  const { accessToken } = props;
  return async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        headers: {
          authorization: "Bearer " + accessToken,
        },
        // url: "http://localhost:8301/partner-payout-service/pricing/partner-by-stages?stage=2",
         url: `${Payout_Service}/pricing/partner-by-stages?stage=2`,
      });
      const data = response.data;
      console.log("data",data);
      
      dispatch({
        type: partnerDetailbyStatusAction.PARTNER_DETAIL_FOR_QUERY_SUCCESS,
        payload: data.data,
      });
      return data.data;
    } catch (error) {
      console.error("Error:", error);
      dispatch({
        type: partnerDetailbyStatusAction.PARTNER_DETAIL_FOR_QUERY_ERROR,
        payload: error.message || "Failed to fetch partner data",
      });
    }
  };
}
export function partnerDetailForResolved(props) {
  const { accessToken } = props;
  return async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        headers: {
          authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Origin": "*",
        },
        // url: "http://localhost:8301/partner-payout-service/pricing/partner-by-stages?stage=3",
        url: `${Payout_Service}/pricing/partner-by-stages?stage=3`,
      });
      const data = response.data;
      dispatch({
        type: partnerDetailbyStatusAction.PARTNER_DETAIL_FOR_RESOLVED_SUCCESS,
        payload: data.data,
      });
      return data.data;
    } catch (error) {
      console.error("Error:", error);
      dispatch({
        type: partnerDetailbyStatusAction.PARTNER_DETAIL_FOR_RESOLVED_ERROR,
        payload: error.message || "Failed to fetch partner data",
      });
    }
  };
}
